import React from "react";
import payment from "../Assets/Images/resp/payment.png";
import discount from "../Assets/Images/resp/discount.png";
import delivery from "../Assets/Images/resp/delivery.png";
import "../Assets/Styles/layouts/footer.scss";
export default function Footer() {
  return (
    <React.Fragment>
      <section className="before-footer u-margin-bottom-sm " style={{ marginBottom: "5rem" }}>
        <div className="caption">
          <p>
            We deliver everything in 4 hours GroMart is India’s fastest online shopping platform. Get fresh groceries and much
            more <br />
            delivered online instantly.
          </p>
        </div>
        <div className="resp-images  u-margin-top-sm">
          <div className="img-container">
            <img alt="Payments" src={payment} />
          </div>
          <div className="img-container">
            <img alt="Discounts" src={discount} />
          </div>
          <div className="img-container">
            <img alt="Delivery" src={delivery} />
          </div>
        </div>
      </section>
      <span className="seprator"></span>
      <footer className="footer u-margin-top-sm" style={{ marginBottom: "5rem" }}>
        <div className="footer-section-container">
          <div style={{ height: "11rem", marginTop: "-5rem", marginLeft: "-5.5rem" }}>
            <svg width="15rem" height="15rem" viewBox="0 0 320 112.26319940520736" className="css-1j8o68f">
              <g
                id="SvgjsG1473"
                featurekey="nameFeature-0"
                transform="matrix(1.521385664394431,0,0,1.521385664394431,117.56577945479347,16.74492739896352)"
                fill="#ff5722"
              >
                <path d="M20.322 27.345 c1.213 0 2.196 0.98328 2.196 2.196 c0 5.7668 -4.692 10.459 -10.459 10.459 s-10.459 -4.692 -10.459 -10.459 l0 -7.0824 c0 -5.7668 4.692 -10.459 10.459 -10.459 s10.459 4.692 10.459 10.459 c0 1.2128 -0.98328 2.196 -2.196 2.196 s-2.196 -0.98328 -2.196 -2.196 c0 -3.3452 -2.7215 -6.0668 -6.0668 -6.0668 s-6.0668 2.7215 -6.0668 6.0668 l0 7.0824 c0 3.3452 2.7215 6.0668 6.0668 6.0668 c2.571 0 4.7736 -1.6075 5.6556 -3.8706 l-5.6554 0 c-1.2128 0 -2.196 -0.98328 -2.196 -2.196 s0.98328 -2.196 2.196 -2.196 l8.2627 0 z M34.748 19.412 c1.2128 0 2.196 0.98328 2.196 2.196 s-0.98328 2.196 -2.196 2.196 c-3.2543 0 -5.902 2.6476 -5.902 5.902 l0 8.098 c0 1.2128 -0.98328 2.196 -2.196 2.196 s-2.196 -0.98328 -2.196 -2.196 l0 -16.196 c0 -1.2128 0.98328 -2.196 2.196 -2.196 c1.1071 0 2.0201 0.81996 2.1716 1.885 c1.677 -1.1856 3.721 -1.885 5.9264 -1.885 z M47.162 19.412 c5.6764 0 10.294 4.6176 10.294 10.294 s-4.6176 10.294 -10.294 10.294 s-10.294 -4.6176 -10.294 -10.294 s4.6176 -10.294 10.294 -10.294 z M47.162 35.608 c3.2543 0 5.902 -2.6476 5.902 -5.902 s-2.6476 -5.902 -5.902 -5.902 s-5.902 2.6476 -5.902 5.902 s2.6476 5.902 5.902 5.902 z M81.5 31.9008 c0 0.00054688 0 0.0010938 0.00054688 0.0016406 l0 5.9014 c0 1.2128 -0.98328 2.196 -2.196 2.196 s-2.196 -0.98328 -2.196 -2.196 l0 -4.9925 l-13.314 -13.314 l0 18.306 c0 1.2128 -0.98328 2.196 -2.196 2.196 s-2.196 -0.98328 -2.196 -2.196 l0 -23.608 c0 -0.88832 0.535 -1.6891 1.3555 -2.0289 c0.82104 -0.33957 1.7654 -0.15207 2.3932 0.476 l7.3 7.3 l7.3 -7.3 c0.6278 -0.62808 1.5726 -0.8164 2.3932 -0.476 c0.82052 0.33984 1.3555 1.1406 1.3555 2.0289 l0 17.705 z M73.557 23.049 l3.5513 3.551 l0 -7.1024 z M101.848 19.412 c1.2128 0 2.196 0.98328 2.196 2.196 l0 16.196 c0 1.2128 -0.98328 2.196 -2.196 2.196 c-1.1071 0 -2.0201 -0.81968 -2.1716 -1.885 c-1.677 1.1856 -3.721 1.885 -5.9264 1.885 c-5.6764 0 -10.294 -4.6176 -10.294 -10.294 s4.6176 -10.294 10.294 -10.294 c2.2054 0 4.2492 0.69944 5.9264 1.885 c0.15152 -1.0654 1.0645 -1.885 2.1716 -1.885 z M93.75 35.608 c3.2543 0 5.902 -2.6476 5.902 -5.902 s-2.6476 -5.902 -5.902 -5.902 s-5.902 2.6476 -5.902 5.902 s2.6476 5.902 5.902 5.902 z M116.28399999999999 19.412 c1.2128 0 2.196 0.98328 2.196 2.196 s-0.98328 2.196 -2.196 2.196 c-3.2543 0 -5.902 2.6476 -5.902 5.902 l0 8.098 c0 1.2128 -0.98328 2.196 -2.196 2.196 s-2.196 -0.98328 -2.196 -2.196 l0 -16.196 c0 -1.2128 0.98328 -2.196 2.196 -2.196 c1.1071 0 2.0201 0.81996 2.1716 1.885 c1.677 -1.1856 3.721 -1.885 5.9264 -1.885 z M130.863 35.608 c1.2128 0 2.1961 0.98332 2.1961 2.1961 s-0.98328 2.196 -2.196 2.196 c-5.7668 0 -10.459 -4.692 -10.459 -10.459 l0 -15.345 c0 -1.2128 0.98328 -2.196 2.196 -2.196 s2.196 0.98328 2.196 2.196 l0 5.2217 l6.0666 0 c1.2128 0 2.196 0.98328 2.196 2.196 s-0.98328 2.196 -2.196 2.196 l-6.0666 0 l0 5.7312 c0 3.3452 2.7215 6.0668 6.0668 6.0668 z" />
              </g>
              <defs id="SvgjsDefs1471" />
            </svg>
          </div>

          <div className="footer-section-container">
            <div className="foot-sec-1 down-space">
              <span>Address:</span>
              <a href="/address"> 5/22 Kormangala, Bengaluru, India</a>
            </div>
            <div className="foot-sec-1 down-space">
              <span>Email: </span>
              <a href="mailto:sales@gromart"> sales@gromart</a>
              <a href="mailto:enquiry@gromart"> enquiry@gromart</a>
            </div>
            <div className="foot-sec-1 down-space ">
              <span>Call us:</span>
              <a href="callto:9611777250"> 1800 000 000 </a>
            </div>
          </div>
        </div>

        <div className="footer-section-container">
          <h3 className="footer-heading">Company</h3>
          <div className="foot-sec-1 down-space">
            <a href="/aboutus">About us</a>
            <a href="/privacy-Policy">Privacy Policy</a>
            <a href="/Terms-and-Conditions">Terms & Conditions</a>
            <a href="/delivey-information">Delivey Information</a>
            <a href="/Contact-us">Contact Us</a>
          </div>
        </div>
        <div className="footer-section-container">
          <h3 className="footer-heading">Corporate</h3>
          <div className="foot-sec-1 down-space">
            <a href="/Become a Vendor"> Become a Vendor</a>
            <a href="/Affiliate Program">Affiliate Program</a>
            <a href="/Affiliate Program">Affiliate Program</a>
            <a href="/Our Suppliers">Our Suppliers</a>
            <a href="/Accessibility">Accessibility</a>
          </div>
        </div>
        <div className="footer-section-container">
          <h3 className="footer-heading">Account</h3>
          <div className="foot-sec-1 down-space">
            <a href="Sign In">Sign In</a>
            <a href="/cart">View Cart</a>

            <a href="Track My Order">Track My Order</a>
            <a href="Help Ticket">Help Ticket</a>
            <a href="Shipping Details">Shipping Details</a>
          </div>
        </div>
      </footer>
    </React.Fragment>
  );
}
